function SpeechToGesture({ setMode }) {
    return (
        <div className="speech-to-gesture-container">
            {/* future implementation */}
            <button onClick={() => setMode('gestureToSpeech')}>ASL To Speech</button>
        </div>
    );
}

export default SpeechToGesture;